import cx from 'classnames';
import React, { useCallback, useContext, useState } from 'react';
import ExperimentProviderContext from '|/helpers/experiment/experiment/provider';
import styles from './control-panel.module.css';

const ExperimentBucketing = () => {
  const { UpdateAssignedBucketByExperimentName, experiments } =
    useContext(ExperimentProviderContext);
  const [showExperiments, setShowExperiments] = useState(false);

  const showHideExperiments = useCallback(() => {
    setShowExperiments(currentShowExperiments => !currentShowExperiments);
  }, [setShowExperiments]);

  const updateBucket = useCallback(
    (experimentName: string, bucketName: string) => {
      UpdateAssignedBucketByExperimentName({ bucketName, experimentName });
    },
    [UpdateAssignedBucketByExperimentName]
  );

  const isProduction = process.env.NODE_ENV === 'production';
  const hasExperiments = Object.keys(experiments).length > 0;

  if (isProduction || !hasExperiments) return null;

  return (
    <div className={cx(styles.wrapper, showExperiments && styles.expanded)}>
      <button
        className={cx(styles.tab, showExperiments && styles.expanded)}
        onClick={showHideExperiments}
        data-analytics-id="pp_devpanel_experiments_header"
      >
        Experiments
      </button>
      {showExperiments && (
        <div className={styles.content}>
          {Object.keys(experiments).map(experimentName => (
            <div key={experimentName} className={styles.experimentGroup}>
              <b>{experimentName}</b>
              {(experiments[experimentName].buckets || []).sort().map(bucket => {
                const id = `${experimentName}-${bucket}`;
                return (
                  <label key={id} htmlFor={id} className={styles.radio}>
                    <input
                      type="radio"
                      name={id}
                      id={id}
                      value={bucket}
                      onChange={() => {
                        updateBucket(experimentName, bucket);
                      }}
                      checked={bucket === experiments[experimentName].assignedBucket}
                    />
                    <div>{bucket}</div>
                  </label>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExperimentBucketing;
